// extracted by mini-css-extract-plugin
export default {"docRoot":"docRoot_UBD9","docsWrapper":"docsWrapper_hBAB"};